import '@/shared/styles/_index.scss'
import '@/shared/styles/globals.css'
import { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import App from './app'
import './shared/i18n'

// --- THÊM ĐOẠN CODE BẮT LỖI VITE Ở ĐÂY ---
window.addEventListener('vite:preloadError', (event) => {
  // Ngăn trình duyệt ném lỗi đỏ lòm ra màn hình
  event.preventDefault()
  // Tải lại trang để lấy code mới nhất từ server
  window.location.reload()
})
// -----------------------------------------

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error(
    "Root element not found. Check if it's in your index.html or if the id is correct."
  )
}

ReactDOM.createRoot(rootElement).render(
  <Suspense fallback="loading...">
    <App />
  </Suspense>
)
